import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/shop-check-instructions",
    name: "ShopCheckInstructions",
    meta: {
      title: "上传指南",
      unusedToken: true
      // showHeader: inMobileApp()
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-check" */ "@/views/shop-check/ShopCheckInstructions.vue"
      )
  },
  {
    path: "/wt-shop-detail",
    name: "ShopDetail",
    meta: {
      title: "门店信息",
      showHeader: true,
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-detail" */ "@/views/shop-check/ShopDetail.vue"
      )
  },
  {
    path: "/wt-shop-task",
    name: "ShopTask",
    meta: {
      title: "店检任务",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-task" */ "@/views/shop-check/ShopTask.vue"
      )
  },
  {
    path: "/wt-shop-list",
    name: "ShopList",
    meta: {
      title: "优秀门店榜单",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-list" */ "@/views/shop-check/ShopList.vue"
      )
  },
  {
    path: "/wt-shop-verify-evaluate",
    name: "ShopVerifyEvaluate",
    meta: {
      title: "审核评价",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-verify-evaluate" */ "@/views/shop-check/ShopVerifyEvaluate.vue"
      )
  },
  {
    path: "/wt-shop-verify-detail",
    name: "ShopVerifyDetail",
    meta: {
      title: "门店查看详情"
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-shop-verify-detail" */ "@/views/shop-check/ShopVerifyDetail.vue"
      )
  },
  {
    path: "/wt-shop-task-detail/:id",
    name: "ShopTaskDetail",
    meta: {
      title: "店检任务详情",
      showHeader: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-shop-task-detail" */ "@/views/shop-check/ShopTaskDetail.vue"
      )
  },
  {
    path: "/wt-shop-check-guide",
    name: "ShopCheckGuide",
    meta: {
      title: "上传指南", // 新版本的
      showHeader: true,
      unusedToken: true
    },
    component: () =>
      import(
        /* webpackChunkName: "shop-guide" */ "@/views/shop-check/ShopCheckGuide.vue"
      )
  }
];
